import * as React from 'react';
export const starFilledSvg = React.forwardRef(function starFilledSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.995 1.01c-.422-.8-1.568-.8-1.99 0l-1.87 3.546-3.95.683A1.125 1.125 0 0 0 .57 7.132l2.794 2.874-.571 3.968a1.125 1.125 0 0 0 1.61 1.17L8 13.375l3.597 1.769a1.125 1.125 0 0 0 1.61-1.17l-.57-3.968 2.793-2.874a1.125 1.125 0 0 0-.615-1.893l-3.95-.683-1.87-3.545Z',
    }),
  );
});
starFilledSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var starFilled = {
  category: 'icon',
  colorable: true,
  name: 'starFilled',
  svg: starFilledSvg,
};
